/**
 * @generated SignedSource<<85f0f57c0d29d5d813cc2ad769b11035>>
 * @relayHash e51a10b0b26310570007b730f952678c
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-commerce/458.0.0-2024-04-17T06:58:39.973Z/submitStripePaymentMethodCreateSetupIntentMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type CreateStripeSetupIntentInput = {
  clientMutationId?: string | null;
  currency?: Currency | null;
  userId: string;
};
export type submitStripePaymentMethodCreateSetupIntentMutation$variables = {
  input: CreateStripeSetupIntentInput;
};
export type submitStripePaymentMethodCreateSetupIntentMutation$data = {
  readonly createStripeSetupIntent: {
    readonly setupIntent: {
      readonly clientSecret: string | null;
    } | null;
  } | null;
};
export type submitStripePaymentMethodCreateSetupIntentMutation = {
  response: submitStripePaymentMethodCreateSetupIntentMutation$data;
  variables: submitStripePaymentMethodCreateSetupIntentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateStripeSetupIntentPayload",
    "kind": "LinkedField",
    "name": "createStripeSetupIntent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "SetupIntent",
        "kind": "LinkedField",
        "name": "setupIntent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "clientSecret",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "submitStripePaymentMethodCreateSetupIntentMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "submitStripePaymentMethodCreateSetupIntentMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-commerce/458.0.0-2024-04-17T06:58:39.973Z/submitStripePaymentMethodCreateSetupIntentMutation",
    "metadata": {},
    "name": "submitStripePaymentMethodCreateSetupIntentMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "3a7eb7a83b1edb7f9c3252adc0d6fc60";

export default node;
